.inputs-container {
  .input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  select {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .select > div {
    margin-right: -1px;
  }
}

.inputs-container--small-screen-xs {
  @media only screen and (max-width: 600px) {
    .input {
      border-top-right-radius: 0;
    }

    select {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      margin-bottom: -1px;
    }
  }
}

.inputs-container--small-screen-sm {
  @media only screen and (max-width: 960px) {
    .input {
      border-top-right-radius: 0;
    }

    select {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      margin-bottom: -1px;
    }
  }
}

.inputs-container--small-screen-md {
  @media only screen and (max-width: 1280px) {
    .input {
      border-top-right-radius: 0;
    }

    select {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      margin-bottom: -1px;
    }
  }
}

.inputs-container--small-screen-lg {
  @media only screen and (max-width: 1920px) {
    .input {
      border-top-right-radius: 0;
    }

    select {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      margin-bottom: -1px;
    }
  }
}

.inputs-container--small-screen-xl {
  .input {
    border-top-right-radius: 0;
  }

  select {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    margin-bottom: -1px;
  }
}

.select:focus-visible,
.select:hover {
  z-index: var(--dds-zindex-absolute-element);
  & ~ svg {
    z-index: var(--dds-zindex-absolute-element);
  }
}

.calling-code {
  left: var(--dds-spacing-x0-5);
}

.calling-code--disabled {
  color: var(--dds-color-text-subtle);
}
